import { useFormContext, Controller } from "react-hook-form";

import Box from "ds/components/Box";
import FullScreenModalBody from "ds/components/FullScreenModal/Body";
import FullScreenModalBodyHeader from "ds/components/FullScreenModal/BodyHeader";
import useTypedContext from "hooks/useTypedContext";

import DefinedRegionsCard from "./DefinedRegionsCard";
import ResourceTypesField from "./ResourceTypesField";
import { NewScanScheduleContext } from "../../context";
import { SCHEDULE_SCAN_WIZARD_STEP_HEADERS } from "../../constants";
import useScanProviderSchema from "../../hooks/useScanProviderSchema";
import { NewScanScheduleStep, NewScanScheduleFormFields } from "../../types";

const NewScanScheduleStepDefineScope = () => {
  const { control, watch } = useFormContext<NewScanScheduleFormFields>();
  const { goToStep } = useTypedContext(NewScanScheduleContext);

  const {
    regions: regionOptions,
    resourceTypes: resourceTypeOptions,
    loading: schemaLoading,
    error: schemaError,
  } = useScanProviderSchema();

  const regions = watch("regions");
  const resourceTypesHelperText = schemaError ? "Could not load resource types." : undefined;

  return (
    <FullScreenModalBody zeroMinHeight>
      <FullScreenModalBodyHeader
        {...SCHEDULE_SCAN_WIZARD_STEP_HEADERS[NewScanScheduleStep.DefineScope]}
      />
      <Box direction="column" gap="large" grow="1" zeroMinHeight>
        <DefinedRegionsCard
          regions={regions}
          regionOptions={regionOptions}
          onEditRegions={() => goToStep(NewScanScheduleStep.AttachProviders)}
        />

        <Controller
          name="resourceTypes"
          control={control}
          rules={{ validate: (value) => value.length > 0 || "Select at least one resource type." }}
          render={({ field, fieldState }) => (
            <ResourceTypesField
              value={field.value}
              onChange={field.onChange}
              options={resourceTypeOptions}
              isLoading={schemaLoading}
              error={fieldState.error?.message}
              helperText={resourceTypesHelperText}
            />
          )}
        />
      </Box>
    </FullScreenModalBody>
  );
};

export default NewScanScheduleStepDefineScope;
